module.exports = __webpack_public_path__ + "img/11 Aniamtion 3-squashed.de0c9f4f.jpg";